import { z } from 'zod';
import { categoryLensKeys } from './categoryLens';

// The selected lens and Loop scope live in the URL so they survive a refresh and can be shared or
// linked to.
//
// `.catch(undefined)` rather than a hard failure: a hand-edited, bookmarked or stale link with an
// unknown lens or a malformed loop id must land on the unfiltered feed, never on the error boundary.
// A filter is not worth breaking a page over.
export const loopIntelligenceSearchSchema = z.object({
  lens: z.enum(categoryLensKeys).optional().catch(undefined),
  loop: z.coerce.number().int().positive().optional().catch(undefined),
});

export type LoopIntelligenceSearch = z.infer<typeof loopIntelligenceSearchSchema>;
